import React from 'react';
import PropTypes from 'prop-types';
import {GradientBackground, BoxArtifact, Video} from '../../';
import isEqual from 'lodash.isequal';

export default class TrailerSection extends React.Component {
    static propTypes = {
        trailerData: PropTypes.object,
        active: PropTypes.bool,
        height: PropTypes.number,
        width: PropTypes.number,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    state = {
        play: false,
        trailerData: {}
    };

    componentWillReceiveProps(nextProps) {
        if (!nextProps.active && this.state.play) {
            this.setState({
                play: false
            });
        }
    }

    componentWillMount() {
        if (!isEqual(this.props.trailerData, this.state.trailerData)) {
            this.setState({
                trailerData: this.props.trailerData
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!isEqual(nextState, this.state)) {
            return true;
        }

        const p = this.props;
        if (nextProps.active !== p.active || nextProps.height !== p.height || nextProps.width !== p.width) {
            return true;
        }

        if (!isEqual(this.state.trailerData, nextState.trailerData)) {
            return true;
        }

        return false;
    }

    playPause = () => {
        this.setState({
            play: !this.state.play
        });
    };

    closeVideo = () => {
        this.setState({
            play: false
        });
    };

    render() {
        const trailerData = this.state.trailerData || {};
        const videoId = trailerData.videoID || '';
        const {active, mobile, tablet} = this.props;
        const titleClass = active ? 'title active' : 'title not-visible';
        const hideArtifact = true; //mobile || tablet;
        const bot1Style = active ? 'bot-1 active' : 'bot-1';

        let zIndex = 9999;
        if (this.state.play) {
            zIndex = -1;
        }

        return (
            <div id="trailerSection" className="section" >
                <GradientBackground
                    mobile={mobile}
                    tablet={tablet}
                    gradient="redBlue"
                    top="white"
                    bottom="white"
                    image={true}
                    active={active} />
                <div role="presentation" onClick={this.closeVideo} className={`overlay ${this.state.play ? 'on' : ''}`} />
                {!hideArtifact ?
                    <BoxArtifact
                        top={12} finalPosition={34} ready={active} reset={!active}
                        zIndex={zIndex} /> : ''}
                {!hideArtifact ?
                    <BoxArtifact
                        top={80} finalPosition={12} ready={active} reset={!active}
                        zIndex={zIndex} /> : ''}
                {!hideArtifact ?
                    <BoxArtifact
                        right={true} top={40} finalPosition={16} ready={active}
                        reset={!active} zIndex={zIndex} /> : ''}
                <div className={titleClass}>
                    <h1><span>{this.state.trailerData.title}</span></h1>
                    <h1><span>{this.state.trailerData.titleTwo}</span></h1>
                </div>

                <Video
                    video={videoId}
                    active={active}
                    play={this.state.play}
                    playPauseFunc={this.playPause}
                    poster={true}
                    align="left"
                    backShadow={true}
                    buttonColor="yellow" />
                <div className={bot1Style} />
            </div>
        );
    }
}

